var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRedeemCoupon = function SvgRedeemCoupon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3481_32147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 4C21.1046 4 22 4.89543 22 6H20V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 18C22 19.1046 21.1046 20 20 20L20 18L22 18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 8H22V10H20V8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14H22V16H20V14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18H18V20H16V18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.1764,
    y: 2,
    width: 2,
    height: 20,
    transform: "rotate(15 17.1764 2)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 20H14.4258L14.9613 18H4V15.46C5.19 14.77 6 13.47 6 12C6 10.52 5.2 9.23 4.01 8.54L4 6H18.1742L18.7097 4H4C2.9 4 2.01 4.9 2.01 6V10C3.11 10 4 10.9 4 12C4 13.1 3.11 14 2 14V18C2 19.1 2.9 20 4 20ZM12 14.12L9.07 16L9.95 12.63L7.26 10.43L10.73 10.22L12 7L13.26 10.23L16.73 10.44L14.04 12.64L14.93 16L12 14.12Z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-1_3481_32147",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0956 13.8213C17.8082 13.2593 17.6578 12.6372 17.6569 12.006C17.6559 11.3747 17.8043 10.7522 18.0901 10.1893L19.8735 11.0946C19.7306 11.376 19.6564 11.6873 19.6569 12.0029C19.6573 12.3185 19.7325 12.6296 19.8762 12.9106L18.0956 13.8213Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.0956 13.8213C17.8082 13.2593 17.6578 12.6372 17.6569 12.006C17.6559 11.3747 17.8043 10.7522 18.0901 10.1893L19.8735 11.0946C19.7306 11.376 19.6564 11.6873 19.6569 12.0029C19.6573 12.3185 19.7325 12.6296 19.8762 12.9106L18.0956 13.8213Z",
    stroke: "#323232",
    strokeWidth: 4,
    mask: "url(#path-8-inside-1_3481_32147)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3481_32147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRedeemCoupon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "redeem-coupon.2d95aee49e581fd5ac5014d6528489b6.svg";